import React, { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import api, { formatApiError } from "../lib/api";

export default function ForgotPassword() {
    const [email, setEmail] = useState("");
    const [loading, setLoading] = useState(false);
    const [sent, setSent] = useState(false);

    React.useEffect(() => {
        document.title = "Forgot Password | Loomara";
    }, []);

    const submit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await api.post("/auth/forgot-password", { email });
            setSent(true);
            toast("If that email is registered, a reset link is on its way.");
        } catch (err) {
            toast(formatApiError(err.response?.data?.detail) || "Could not send reset email");
        } finally {
            setLoading(false);
        }
    };

    return (
        <section className="min-h-[80vh] flex items-center justify-center container-boutique py-16" data-testid="forgot-password-page">
            <section className="card-soft p-10 w-full max-w-md">
                <p className="eyebrow text-center">Account</p>
                <h1 className="font-serif text-4xl text-ink-900 text-center mt-2 mb-8">Forgot password</h1>
                {sent ? (
                    <p className="text-sm text-ink-600 text-center leading-relaxed">
                        Check your inbox for a reset link. It expires in one hour.
                    </p>
                ) : (
                    <form onSubmit={submit} className="space-y-4">
                        <input
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            type="email"
                            required
                            placeholder="Email"
                            className="w-full bg-ivory-100 rounded-xl px-4 py-3 text-sm border border-sage-300/30 focus:outline-none focus:ring-2 focus:ring-sage-300"
                            data-testid="forgot-email"
                        />
                        <button disabled={loading} className="btn-primary w-full" data-testid="forgot-submit">
                            {loading ? "Sending…" : "Send reset link"}
                        </button>
                    </form>
                )}
                <p className="text-center text-sm text-ink-500 mt-6">
                    <Link to="/login" className="text-sage-700 underline underline-offset-4" data-testid="link-login">
                        Back to sign in
                    </Link>
                </p>
            </section>
        </section>
    );
}
